import { render, staticRenderFns } from "./Invite-invalid.vue?vue&type=template&id=258532b1&scoped=true";
import script from "./Invite-invalid.vue?vue&type=script&lang=js";
export * from "./Invite-invalid.vue?vue&type=script&lang=js";
import style0 from "./Invite-invalid.vue?vue&type=style&index=0&id=258532b1&prod&lang=less&scoped=true";

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js";
var component = normalizer(script, render, staticRenderFns, false, null, "258532b1", null);
export default component.exports;